import { useAppSelector } from '../contexts/hooks';

/**
 * Hook para verificar si el componente actual es la tab activa.
 * Los componentes hijos de infoOrder pueden usar este hook para decidir
 * si deben consultar APIs cuando idOrd cambia.
 * 
 * @param tabId - ID de la tab (1=Studies, 2=Results, 3=Notes, 4=Attachments, 5=Tracking, 6=SerumLibrary)
 * @returns true si esta tab es la actualmente visible
 * 
 * @example
 * ```tsx
 * const OrdResults = () => {
 *   const isActiveTab = useActiveTab(2); // 2 = Results
 *   const idOrd = useAppSelector(x => x.globalOrders.CurrentOrder.IdOrder);
 * 
 *   useEffect(() => {
 *     if (isActiveTab) {
 *       // Solo consultar API si esta tab está visible
 *       fetchResults(idOrd);
 *     }
 *   }, [idOrd, isActiveTab]);
 * };
 * ```
 */
export const useActiveTab = (tabId: number): boolean => {
  const currentActiveTab = useAppSelector((x) => x.globalOrders.currentActiveTab);
  return currentActiveTab === tabId;
};
